declare global {
	interface Window {
		ReactNativeWebView?: { postMessage: (message: string) => void };
		__pxNative?: {
			platform?: string;
			version?: string;
			fromManagerPanel?: boolean;
		};
		__pxOpenDeepLink?: (deepLink: string) => void;
	}
}

export const NATIVE_APP_CLASS_NAME = 'is-native-app';

export const NATIVE_DELETE_ACCOUNT_MESSAGE = 'panel:delete-account';

export const NATIVE_DOWNLOAD_FILE_MESSAGE = 'panel:download-file';

export const NATIVE_SWITCH_PANEL_MESSAGE = 'panel:switch-panel';

export const NATIVE_DEEP_LINK_BRIDGE_KEY = '__pxOpenDeepLink' as const;

export const isNativeApp = () =>
	process.env.NEXT_PUBLIC_FORCE_NATIVE_APP === 'true' ||
	(typeof window !== 'undefined' && !!window.ReactNativeWebView);

export const isNativeManagerAccess = () =>
	isNativeApp() &&
	typeof window !== 'undefined' &&
	window.__pxNative?.fromManagerPanel === true;

export const postNativeMessage = (payload: Record<string, unknown>) => {
	if (!isNativeApp()) return false;

	window.ReactNativeWebView?.postMessage(JSON.stringify(payload));

	return true;
};
